var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectSentiment !== 'POSITIVE')?_c('div',{staticClass:"card pt-4 px-4 text-center"},[_c('h3',{staticClass:"text-muted mb-0",staticStyle:{"font-size":"14px"}},[_vm._v("Incidents")]),_c('apexchart',{attrs:{"height":_vm.heatmapHeight + 'px',"type":"heatmap","series":_vm.series,"options":_vm.chartOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }